// extracted by mini-css-extract-plugin
module.exports = {"cartPaymentMethod":"cart-payment-method_cartPaymentMethod__1cESI","header":"cart-payment-method_header__2tatQ","link":"cart-payment-method_link__1346A"};